import { getTasks, addTask } from '../tasks';
import { exportActivities } from './index';

const exportTasks = data => {
    return exportActivities({ ...data, getter: getTasks, adder: addTask });
};

export default exportTasks;
